import React from 'react';
import Banner from './Banner';
import ProductSlider from './ProductSlider';
import { FaAward, FaIndustry, FaFlask, FaGlobe, FaCertificate, FaTruck, FaHandshake, FaChartLine } from 'react-icons/fa';
import './Home.css';

const Home = () => {
    const stats = [
        { number: '1000+', label: 'Products' },
        { number: '50+', label: 'Countries' },
        { number: '500+', label: 'Partners' },
        { number: '15+', label: 'Years Experience' }
    ];
    const certifications = [
        'WHO GMP',
        'GMP',
        'GLP',
        'CGMP',
        'ISO 9000'
    ];

    const features = [
        {
            icon: <FaCertificate />,
            title: 'Exemplary Quality',
            description: 'Every product meets rigorous quality standards, ensuring reliability and excellence'
        },
        {
            icon: <FaTruck />,
            title: 'Punctual Deliveries',
            description: 'Our robust logistics network ensures your orders are delivered on schedule, every time'
        },
        {
            icon: <FaHandshake />,
            title: 'Exceptional Value',
            description: 'Competitive pricing without compromising on quality, making us your preferred partner'
        },
        {
            icon: <FaGlobe />,
            title: 'Domestic & Export Excellence',
            description: 'Products manufactured in state-of-the-art facilities with US FDA, EU GMP, WHO GMP, CGMP, and ISO 9000 certifications'
        }
    ];

    const achievements = [
        { icon: <FaAward />, text: 'Quality Excellence' },
        { icon: <FaTruck />, text: 'On-Time Delivery' },
        { icon: <FaHandshake />, text: 'Trusted Partnerships' },
        { icon: <FaChartLine />, text: 'Continuous Growth' }
    ];

    return (
        <div className="home-container">
            <Banner />

            {/* Welcome Section */}
            {/* <section className="welcome-section">
                <div className="welcome-content">
                    <h1>Welcome to D-Astars Healthcare</h1>
                    <p>A leading pharmaceutical company dedicated to manufacturing and marketing high-quality pharmaceutical formulations worldwide.</p>
                </div>
            </section> */}

            {/* Stats Section */}
            {/* <section className="stats-section">
                <div className="stats-container">
                    {stats.map((stat, index) => (
                        <div key={index} className="stat-card">
                            <h3>{stat.number}</h3>
                            <p>{stat.label}</p>
                        </div>
                    ))}
                </div>
            </section> */}

        <div className="about-container">
            <section className="about-intro">
                <h1>About D-Astars</h1>
                <p>Welcome to D-Astars International Trade, a trusted and registered Indian pharmaceutical company dedicated to the manufacturing and marketing of top-quality pharmaceutical formulations. With our own state-of-the-art manufacturing unit featuring sections for Tablets, Capsules, Soft Gelatin Capsules, Betalactum Products, and General Products, we cater to diverse healthcare needs.</p>
                <p>D-Astars proudly serves clients across India and extends its expertise to international markets. Our products are legally approved by relevant authorities and adhere strictly to compliance standards such as WHO-GMP, GMP, and GLP. Our offerings span a wide array of therapeutic segments, including Cardiac, Diabetic, Anticoagulants, Analgesics, Vasodilators, Gastrology, Orthopedics, Respiratory, and General Products.</p>
            </section>

            <section className="company-pillars">
                <div className="pillar-card">
                    <h2>Mission</h2>
                    <p>Our mission is to harness the transformative power of pharmaceuticals to address rare, chronic, and severe illnesses. We are dedicated to providing exceptional, high-quality products that enhance the well-being and health of patients worldwide, ensuring care and innovation are at the heart of everything we do.</p>
                </div>

                <div className="pillar-card">
                    <h2>Vision</h2>
                    <p>Our vision is to establish ourselves as a premier pharmaceutical leader in India and emerge as a prominent global presence by delivering high-quality, accessible, and innovative healthcare solutions that redefine medicine and treatment for a healthier world.</p>
                </div>

                <div className="pillar-card">
                    <h2>Quality</h2>
                    <p>D-Astars International Trade's Quality Policy is driven by a robust Quality Management System, ensuring continuous monitoring and review to uphold the highest standards for patients, customers, and stakeholders.</p>
                </div>
            </section>

            {/* Product Categories */}
            <section className="product-categories">
                <h2>Our Product Range</h2>
                <ProductSlider />
            </section>

            <section className="why-choose-us">
                <h2>Why Choose D-Astars?</h2>
                <div className="features-grid">
                    <div className="feature-card">
                        <i className="fas fa-medal"></i>
                        <h3>Exemplary Quality</h3>
                        <p>Every product we manufacture meets rigorous quality standards, ensuring reliability and excellence.</p>
                    </div>
                    <div className="feature-card">
                        <i className="fas fa-truck"></i>
                        <h3>Punctual Deliveries</h3>
                        <p>Our robust logistics network ensures your orders are delivered on schedule, every time.</p>
                    </div>
                    <div className="feature-card">
                        <i className="fas fa-globe"></i>
                        <h3>Global Reach</h3>
                        <p>Delivering exceptional quality products globally through air, ocean, and road freight.</p>
                    </div>
                </div>
            </section>

            <section className="certifications">
                <h2>Our Certifications</h2>
                <div className="certification-grid">
                    {certifications.map((cert, index) => (
                        <div key={index} className="certification-badge">
                            <i className="fas fa-certificate"></i>
                            <span>{cert}</span>
                        </div>
                    ))}
                </div>
            </section>
            </div>

            {/* About Section */}
            {/* <section className="about-section">
                <h2>About D-Astars Healthcare</h2>
                <div className="about-content">
                    <p>Welcome to D-Astars International Trade, a trusted and registered Indian pharmaceutical company dedicated to the manufacturing and marketing of top-quality pharmaceutical formulations. With our own state-of-the-art manufacturing unit featuring sections for Tablets, Capsules, Soft Gelatin Capsules, Betalactum Products, and General Products, we cater to diverse healthcare needs.D-Astars proudly serves clients across India and extends its expertise to international markets. Our products are legally approved by relevant authorities and adhere strictly to compliance standards such as WHO-GMP, GMP, and GLP. Our offerings span a wide array of therapeutic segments, including Cardiac, Diabetic, Anticoagulants, Analgesics, Vasodilators, Gastrology, Orthopedics, Respiratory, and General Products.</p>
                    <div className="about-features">
                        <div className="feature">
                            <FaIndustry className="feature-icon" />
                            <h3>Manufacturing Excellence</h3>
                            <p>World-class manufacturing facilities with advanced technology</p>
                        </div>
                        <div className="feature">
                            <FaCertificate className="feature-icon" />
                            <h3>Quality Assurance</h3>
                            <p>WHO-GMP certified facilities with stringent quality controls</p>
                        </div>
                        <div className="feature">
                            <FaGlobe className="feature-icon" />
                            <h3>Global Presence</h3>
                            <p>Serving healthcare needs across multiple countries</p>
                        </div>
                    </div>
                </div>
            </section> */}


            {/* Why Choose Us Section */}
            {/* <section className="why-choose-us">
                <h2>Why Choose D-Astars?</h2>
                <p className="section-intro">At D-Astars, we specialize in the business-to-business trade of pharmaceutical products, ensuring long-term partnerships built on trust, superior service, and competitive terms.</p>
                <h3>What Sets Us Apart?</h3>
                <div className="features-grid">
                    {features.map((feature, index) => (
                        <div key={index} className="feature-card">
                            <div className="feature-icon">{feature.icon}</div>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </section> */}

            {/* Achievements Section */}
            {/* <section className="achievements-section">
                <h2>Our Achievements</h2>
                <div className="achievements-grid">
                    {achievements.map((achievement, index) => (
                        <div key={index} className="achievement-card">
                            <div className="achievement-icon">{achievement.icon}</div>
                            <p>{achievement.text}</p>
                        </div>
                    ))}
                </div>
            </section> */}
        </div>
    );
};

export default Home;
